// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"8f50dfff","498":"d280cfbf","703":"05b57592"}[chunkId] + ".chunk.js";
};